import { FC } from 'react';
import styled from 'styled-components';

const Spinner = styled.div`
  width: 35px;
  aspect-ratio: 1;
  border-radius: 50%;
  background:
    radial-gradient(farthest-side, #357d42 100%, #0000) top/8px 8px no-repeat,
    conic-gradient(#0000 30%, #357d42);
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
  animation: l13 1s infinite linear;

  @keyframes l13 {
    100% {
      transform: rotate(1turn);
    }
  }
`;

interface Props {
  className?: string;
}

const Loading: FC<Props> = ({ className }) => <Spinner className={className} />;

export default Loading;
